import styles from "./DeployAvatarConfirm.module.scss";

interface Props {
	onClose: () => void;
	openCopyLink: () => void;
}

const DeployAvatarConfirm: React.FC<Props> = ({ onClose, openCopyLink }) => {
	return (
		<div className={styles.content}>
			<h2>После публикации ссылки вы больше<br />не сможете внести изменения в настройки проекта.<br />Продолжить?</h2>
			<div className={styles.actionsContainer}>
				<button
					type="button"
					onClick={openCopyLink}
					className={styles.button}
				>
					Да
				</button>
				<button
					type="button"
					onClick={onClose}
					className={styles.button}
				>
					Нет, вернуться к аватару
				</button>
			</div>
		</div>
	);
};

export default DeployAvatarConfirm;
